var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row align-items-center mb-1" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-2 offset-md-4 text-right center" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-warning btn-fill",
              attrs: { type: "submit" },
              on: { click: _vm.editGreeting }
            },
            [_vm._v("Edit Greeting")]
          )
        ])
      ]),
      _vm._v(" "),
      _vm.greeting
        ? _c("div", { staticClass: "table-responsive" }, [
            _c("table", { staticClass: "table table-bordered table-light" }, [
              _c("tr", [
                _c("th", [_vm._v("Id")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.greeting.bannerId))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Message")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.greeting.bannerMessage))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("URL")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.greeting.destinationURL))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Start Date/Time")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.greeting.start_dateFmt))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Start Date/Time")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.greeting.end_dateFmt))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Corporation Name")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.greeting.corporationName))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Display Order")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.greeting.displayOrder))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Status")]),
                _vm._v(" "),
                _vm.greeting.active == "0"
                  ? _c("td", [_vm._v("Inactive")])
                  : _c("td", [_vm._v("Active")])
              ])
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("div", { staticClass: "h2" }, [_vm._v("Greeting Details")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1df1f6d8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1df1f6d8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Greetings/GreetingDetails.vue
// module id = xNN1
// module chunks = 0